import * as React from 'react';
import Icon from 'react-fa';
const styles = require('./Search.less') as any;

const SEARCH_PLACEHOLDER = "drug stores near me, pizza, ... ";
import { purify } from '../../utils'
const SearchBox = purify(({input, label, type, defaultValue=''}) => (
		<div className={styles.SearchBox}>
				<Icon name="search" />
				<input {...input} type='search' placeholder={SEARCH_PLACEHOLDER} />
				<button className={styles.SearchButton} type='submit'>Go!</button>
		</div>
))

export default SearchBox;



// WEBPACK FOOTER //
// ./src/app/containers/Search/SearchBox.tsx